<script>
	export let padding = "6px 16px";

</script>

<div
	class="wx-todo_separator"
	style="padding: {padding};"
	data-separator={true}>
	<div class="wx-todo_separator__line" />
</div>

<style>
	.wx-todo_separator {
		cursor: default;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	:global(.wx-ondrag) .wx-todo_separator {
		cursor: grabbing;
	}
	.wx-todo_separator__line {
		border-bottom: var(--wx-border);
		flex: 1 1 auto;

		touch-action: none;
		user-select: none;
		pointer-events: none;
	}

</style>
